<!-- 资讯页面 -->
<template>
  <div class="newsContainer">
    <div class="newsContent">
      <!-- 左侧 banner -->
      <div class="bannernews">
        <el-carousel
          v-if="bannerItems.length"
          :autoplay="bannerItems.length > 1"
          :interval="4000"
          height="503px"
          :arrow="bannerItems.length > 1 ? 'always' : 'never'"
          indicator-position="outside"
          ref="carousel"
          :class="{ single: bannerItems.length === 1 }"
        >
          <el-carousel-item v-for="(item, idx) in bannerItems" :key="idx">
            <div
              class="banner-item"
              :style="{
                backgroundImage: `url(${item.imgUrl || ''})`,
              }"
              @click="goNewsDetail(item)"
            >
              <div class="banner-mask"></div>
              <div class="banner-overlay">
                <span class="news-type">{{
                  item.newsTypeShow || "未知类型"
                }}</span>
                <div class="news-title">
                  {{ item.title || "--" }}
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <!-- 自定义箭头，放在 carousel 同层级，直接调用 $refs.carousel.prev/next -->
        <div v-if="bannerItems.length > 1" class="custom-arrows">
          <button class="my-arrow left" @click="carouselPrev" type="button">
            <i class="icon-left">
              <img src="../../assets/arrow-left.png" alt="" />
            </i>
          </button>
          <button class="my-arrow right" @click="carouselNext" type="button">
            <i class="icon-right">
              <img src="../../assets/arrow-right.png" alt="" />
            </i>
          </button>
        </div>
      </div>

      <!-- 右侧最新头条 -->
      <div class="latestNews">
        <div class="newsfire">
          <div class="fireleft">
            <img src="../../assets/newsfire.png" alt="" srcset="" />
            <span>最新头条</span>
          </div>
          <div class="trit" @click="handleMoreType('headline')">
            <span>更多</span>
            <svg-icon icon-class="trademore" />
          </div>
        </div>
        <div class="newslist">
          <div v-if="newstopics.length > 0">
            <div class="newrow" v-for="item in newstopics" :key="item.id">
              <div @click="goNewsDetail(item)" class="listtit">
                {{ item.title }}
              </div>
              <div class="listdate">{{ item.releaseTime }}</div>
            </div>
          </div>

          <div v-else>
            <el-empty :image-size="100" description="暂无最新头条！"></el-empty>
          </div>
        </div>
      </div>
    </div>
    <!-- 政策速递 | 行业动态 -->
    <div class="policy-news">
      <!-- 左边政策速递 -->
      <div class="policy-section">
        <div class="section-header">
          <h2><span></span>政策速递</h2>
          <div class="trit" @click="handleMoreType('policy')">
            <span>更多</span>
            <svg-icon icon-class="trademore" />
          </div>
        </div>
        <div class="section-content">
          <div v-if="policyNews.length > 0">
            <div class="news-item" v-for="item in policyNews" :key="item.id">
              <div class="news-left" @click="goNewsDetail(item)">
                <span></span>
                <div class="news-title">{{ item.title }}</div>
              </div>
              <div class="news-date">{{ item.releaseTime }}</div>
            </div>
          </div>
          <div class="news" style="width: 530px" v-else>
            <el-empty :image-size="100" description="暂无政策数据！"></el-empty>
          </div>
        </div>
      </div>
      <!-- 右边行业动态 -->
      <div class="industry-section">
        <div class="section-header">
          <h2><span></span>行业动态</h2>
          <div class="trit" @click="handleMoreType('industry')">
            <span>更多</span>
            <svg-icon icon-class="trademore" />
          </div>
        </div>
        <div class="section-content">
          <div v-if="industryNews.length > 0">
            <div class="news-item" v-for="item in industryNews" :key="item.id">
              <div class="news-left" @click="goNewsDetail(item)">
                <span></span>
                <div class="news-title">{{ item.title }}</div>
              </div>
              <div class="news-date">{{ item.releaseTime }}</div>
            </div>
          </div>

          <div class="news" v-else style="width: 530px">
            <el-empty :image-size="100" description="暂无行业数据！"></el-empty>
          </div>
        </div>
      </div>
    </div>

    <!-- 专栏观点 | 深度研究 -->
    <div class="column-section">
      <!-- 专栏观点 -->
      <div class="column-opinion">
        <div class="section-header">
          <h2><span></span>专栏观点</h2>
          <div class="trit" @click="handleMoreType('opinion')">
            <span>更多</span>
            <svg-icon icon-class="trademore" />
          </div>
        </div>
        <div class="column-section-content">
          <div
            class="column-item"
            v-for="item in columnOpinions"
            :key="item.id"
            @click="goNewsDetail(item)"
          >
            <div class="colunm-img">
              <img
                :src="
                  item.imgUrl || 'https://picsum.photos/seed/column1/128/128'
                "
                alt=""
                srcset=""
              />
            </div>
            <div class="column-txt">
              <div class="column-title">{{ item.title }}</div>
              <div class="column-desc">
                {{
                  item.newsSummary ||
                  "这是专栏观点的简介内容，简要介绍观点的核心内容和亮点，吸引用户点击阅读全文。"
                }}
              </div>
              <div class="column-date">
                <span>{{
                  item.newsYear +
                  "-" +
                  formatNumber(item.newsMonth) +
                  "-" +
                  formatNumber(item.newsDay)
                }}</span>
                <i class="el-icon-right" style="color: #4aab3d"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 深度研究 | 碳索研报 -->
      <div class="deepCaron">
        <!-- 深度研究 -->
        <div class="deep-research">
          <div class="section-header">
            <h2><span></span>深度研究</h2>
            <div class="trit" @click="handleMoreType('research')">
              <span>更多</span>
              <svg-icon icon-class="trademore" />
            </div>
          </div>
          <div class="section-content">
            <!-- 深度研究内容，格式同上 -->
            <div v-if="deepResearch.length > 0">
              <div
                class="news-item"
                v-for="item in deepResearch"
                :key="item.id"
                @click="goNewsDetail(item)"
              >
                <div class="news-left">
                  <span></span>
                  <div class="news-title">{{ item.title }}</div>
                </div>
                <div class="news-date">{{ item.releaseTime }}</div>
              </div>
            </div>

            <div class="news" style="height: 303px" v-else>
              <el-empty
                :image-size="100"
                description="暂无研究数据！"
              ></el-empty>
            </div>
          </div>
          <div class="section-footer"></div>
        </div>
        <!-- 碳索研报 -->
        <div class="carbon-search">
          <div class="section-header">
            <h2><span></span>碳索研报</h2>
            <div class="trit" @click="handInNewsList">
              <span>更多</span>
              <svg-icon icon-class="trademore" />
            </div>
          </div>
          <div class="news" v-if="sortnewsData.length > 0">
            <div class="nlist">
              <ul>
                <li
                  v-for="item in sortnewsData"
                  :key="item.id"
                  @click="handleInNewsDetail(item)"
                >
                  <div class="lileft">
                    <b class="newbs" v-show="item.isNew">NEW</b>
                    <img
                      class="imgdefault"
                      src="../../assets/report.png"
                      alt=""
                    />
                    <img
                      class="imghover"
                      src="../../assets/report_h.png"
                      alt=""
                    />
                    <p>{{ item.reportTitle }}</p>
                  </div>

                  <b class="newsdate">{{ item.reportUpdateTime }}</b>
                </li>
              </ul>
            </div>
          </div>
          <div class="news" v-else>
            <el-empty :image-size="100" description="暂无研报数据！"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { recommedReportList, reportList } from "@/api/report.js"; // 研报
import {
  recommedBannerList,
  reportTopNewsList,
  newsTypeList,
  columnOpinionList,
} from "@/api/news.js"; // 资讯
export default {
  name: "NewsIndex",
  data() {
    return {
      reportDataList: [], // 合集列表
      sortnewsData: [], // 重新排序后的资讯
      reporttop: [
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
      ], // 上面
      reportbot: [
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
      ], // 下面
      // 模拟数据，最多 3 条，便于本地预览
      rawBanner: [
        {
          imgUrl: "https://picsum.photos/seed/news1/1200/700",
          title: "新能源交易市场迎来政策利好，交易活跃度提升",
          type: "行业资讯",
        },
        {
          imgUrl: "https://picsum.photos/seed/news2/1200/700",
          title: "碳中和项目评估方法更新，影响交易定价机制",
          type: "政策解读",
        },
        {
          imgUrl: "https://picsum.photos/seed/news3/1200/700",
          title: "地方碳市场试点扩围，企业关注合规成本",
          type: "头条",
        },
      ],
      // 最新头条模拟数据
      newstopics: [],
      // 政策速递模拟数据 6条
      policyNews: [],
      // 行业动态模拟数据 6条
      industryNews: [],
      // 专栏观点模拟数据 4条
      columnOpinions: [],
      // 深度研究模拟数据 6条
      deepResearch: [],
    };
  },
  computed: {
    // 最多显示 3 条
    bannerItems() {
      return (this.rawBanner || []).slice(0, 3);
    },
  },
  created() {
    // 获取 banner 数据
    this.fetchBanner();
    // 获取最新头条数据
    this.fetchLatestHeadlines();
    // 获取首页各个类型数据列表
    this.fetchNewsTypeList();
    // 专栏观点
    this.fetchColumnList();
    // 研报列表
    this.getReportList();
    // 合集列表
    this.getReportDataList();
  },
  methods: {
    formatNumber(num) {
      const formattedNum = String(num).padStart(2, "0");
      return formattedNum;
    },
    // 专栏观点
    async fetchColumnList() {
      try {
        const res = await columnOpinionList();
        let list = [];
        if (res) {
          if (res.code === 0 && Array.isArray(res.data)) {
            list = res.data;
          } else if (res.data && Array.isArray(res.data.list)) {
            list = res.data.list;
          } else if (Array.isArray(res)) {
            list = res;
          }
        }
        // 过滤掉 title 为空或仅包含空白的项，并取前 4 条
        this.columnOpinions = list
          .filter((it) => it && it.title && String(it.title).trim().length > 0)
          .slice(0, 4);
      } catch (err) {
        console.error("获取专栏观点失败", err);
      }
    },
    // 获取首页各个类型数据列表 count:条数，newsType:新闻类型：1表示政策速递，2表示行业动态
    async fetchNewsTypeList() {
      try {
        // 请求政策速递（type: policy）和行业动态（type: industry），各 6 条
        const params = { count: 6 };

        const [policyRes, industryRes, deepResearch] = await Promise.all([
          newsTypeList({ ...params, newsType: 1 }),
          newsTypeList({ ...params, newsType: 2 }),
          newsTypeList({ ...params, newsType: 3 }),
        ]);

        const normalize = (res) => {
          let list = [];
          if (res) {
            if (res.code === 0 && Array.isArray(res.data)) {
              list = res.data;
            } else if (res.data && Array.isArray(res.data.list)) {
              list = res.data.list;
            } else if (Array.isArray(res)) {
              list = res;
            }
          }
          // 过滤掉 title 为空或仅包含空白的项，并取前 6 条
          return list
            .filter(
              (it) => it && it.title && String(it.title).trim().length > 0
            )
            .slice(0, 6);
        };

        this.policyNews = normalize(policyRes);
        this.industryNews = normalize(industryRes);
        this.deepResearch = normalize(deepResearch);
      } catch (err) {
        console.error("获取分类资讯失败", err);
      }
    },
    // 跳转更多类型资讯
    handleMoreType(str) {
      this.$router.push("/typelist?type=" + str);
    },
    // 获取最新头条数据
    async fetchLatestHeadlines() {
      try {
        const res = await reportTopNewsList({
          currentPage: 1,
          pageSize: 5,
        });
        // 适配不同返回格式：{ code:0, data: [...] } 或 直接返回数组
        let list = [];
        if (res) {
          if (res.code === 0 && Array.isArray(res.data)) {
            list = res.data;
          } else if (Array.isArray(res)) {
            list = res;
          } else if (res.data && Array.isArray(res.data.list)) {
            list = res.data.list;
          }
        }
        // 赋值（可控制条数，例如最多 10 条）
        this.newstopics = list;
      } catch (error) {
        console.error("获取最新头条失败", error);
      }
    },

    // 如果需要跳转到某条新闻详情
    goNewsDetail(item) {
      if (!item || !item.id) return;
      try {
        const payload = {
          path: this.$route.fullPath,
        };
        sessionStorage.setItem("newsDetailReturn", JSON.stringify(payload));
      } catch (e) {
        console.warn("保存详情返回信息失败", e);
      }
      this.$router.push({
        path: `/newsnoticedetail?newsId=${item.id}&newsSourceShow=${item.newsSourceShow}&path=index`,
      });
    },
    // 研报列表-首页推荐
    getReportList() {
      recommedReportList()
        .then((res) => {
          if (res.code === 0) {
            this.newsData = res.data;
            let fivedaysTime = this.getTimestampFiveDaysAgo();
            this.newsData.map((item) => {
              const reportUpdateTimeTimestamp =
                new Date(item.reportUpdateTime).getTime() / 1000;
              if (reportUpdateTimeTimestamp < fivedaysTime) {
                item.isNew = false;
              } else {
                item.isNew = true;
              }
              item.reportUpdateTime = item.reportUpdateTime.split(" ")[0];
            });
            if (this.newsData.length > 5) {
              this.newsData = this.newsData.slice(0, 5);
            }
            this.sortnewsData = this.newsData.sort((a, b) => b.isNew - a.isNew);
            // console.error(this.sortnewsData,"dcccc")
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 研报合集列表
    getReportDataList() {
      reportList()
        .then((res) => {
          if (res.code === 0) {
            this.reportDataList = res.data;
            // console.error(this.reportDataList)
            let top = this.reportDataList.slice(0, 5);
            let bot = this.reportDataList.slice(5, 20);
            // console.error(top,bot)
            top.map((item, index) => {
              this.reporttop[index]["ishave"] =
                item.reportNumber > 0 ? true : false;
              this.reporttop[index].item.title = item.collectionTitle;
              this.reporttop[index].item.id = item.id;
            });
            bot.map((item, index) => {
              this.reportbot[index]["ishave"] =
                item.reportNumber > 0 ? true : false;
              this.reportbot[index].item.title = item.collectionTitle;
              this.reportbot[index].item.id = item.id;
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 距离当今时间5天前的时间戳返回
    getTimestampFiveDaysAgo() {
      const now = new Date();
      const fiveDaysAgo = new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000);
      return Math.floor(fiveDaysAgo.getTime() / 1000);
    },
    getIntoReport(item) {
      const collectionId = item.id;
      this.$router.push("/reportList?collectionId=" + collectionId);
    },
    // 更多研报
    handInNewsList() {
      this.$router.push({
        path: "/reports",
      });
    },
    // 新闻详情
    handleInNewsDetail(item) {
      this.$router.push({
        path: "/reportPreview?reportId=" + item.id,
      });
    },
    async fetchBanner() {
      try {
        return new Promise((resolve) => {
          recommedBannerList()
            .then((res) => {
              if (res.code === 0) {
                const { data } = res;
                // 判断是否有数据，如果有就赋值，如果没有显示默认值（保留模拟数据）
                if (Array.isArray(data) && data.length > 0) {
                  // 过滤掉 title 为空或仅包含空白的项，保留默认模拟数据如果过滤后为空
                  const filtered = data.filter(
                    (item) =>
                      item && item.title && String(item.title).trim().length > 0
                  );
                  if (filtered.length > 0) {
                    this.rawBanner = filtered.slice(0, 3);
                  } else {
                    // 过滤后无有效数据，不覆盖 rawBanner，保留已有模拟数据或根据需要设置占位
                    // this.rawBanner = [{ image: '/static/placeholder.png', title: '暂无数据', type: '暂无' }];
                  }
                } else {
                  // 不覆盖 rawBanner，保留已有模拟数据或根据需要设置占位
                  // this.rawBanner = [{ image: '/static/placeholder.png', title: '暂无数据', type: '暂无' }];
                }
                resolve(res.data);
              } else {
                resolve(null);
              }
            })
            .catch((err) => {
              console.error("获取 banner 数据失败", err);
              resolve(null);
            });
        });
      } catch (err) {
        console.error("获取 banner 失败，使用模拟数据", err);
        // 保留模拟数据不做处理
      }
    },
    carouselPrev() {
      if (
        this.$refs.carousel &&
        typeof this.$refs.carousel.prev === "function"
      ) {
        this.$refs.carousel.prev();
      }
    },
    carouselNext() {
      if (
        this.$refs.carousel &&
        typeof this.$refs.carousel.next === "function"
      ) {
        this.$refs.carousel.next();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.news {
  width: 544px;
  background-color: #fff;
  .nlist {
    margin-top: 8px;
    .firstnews {
      display: flex;
      flex-direction: space-between;
      cursor: pointer;
      margin-bottom: 4px;
      .firstleft {
        width: 200px;
        height: 118px;
        margin-right: 16px;
        img {
          width: 200px;
          height: 118px;
        }
      }

      .firstright {
        .rtop {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          h4 {
            font-size: 14px;
            color: #03102b;
            font-weight: 600;
            line-height: 22px;
            text-align: left;
            width: 236px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          span {
            color: #03102b;
            opacity: 0.4;
            font-size: 13px;
          }
        }
        .rbot {
          text-align: left;
          margin-top: 8px;
          p {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            color: #83879b;
            display: inline-block;
          }
          i {
            font-size: 12px;
            color: #4aab3d;
            margin-left: 10px;
          }
        }
      }
    }

    ul {
      li {
        font-size: 14px;
        text-align: left;
        line-height: 56px;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        div.lileft {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
        }
        b.newbs {
          width: 28px;
          height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #f24827;
          font-size: 10px;
          font-weight: 600;
          border-radius: 3px;
          border: 1px solid #f24827;
          // padding: 2px;
          // line-height: 12px;
          margin-right: 4px;
        }
        img {
          width: 20px;
          height: 20px;
        }
        .imgdefault {
          display: block;
        }
        .imghover {
          display: none;
        }
        p {
          display: inline-block;
          width: 409px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          vertical-align: middle;
          margin-right: 10px;
          margin-left: 2px;
          font-size: 16px;
          line-height: 24px;
        }
        b.newsdate {
          white-space: nowrap;
          color: #b3b7bf;
        }
      }
      li:hover {
        color: #4aab3d;
        .imgdefault {
          display: none;
        }
        .imghover {
          display: block;
        }
      }
      li:last-child {
        border-bottom: none;
      }
    }
  }
}
.newsContainer {
  padding-top: 72px;
  padding-bottom: 40px;
  background-color: #f6f7f8;
  .newsContent {
    width: 1200px;
    margin: 0 auto;
    margin-top: 42px;
    display: flex;
    gap: 24px;
    .bannernews {
      position: relative; /* 确保自定义箭头绝对定位参照此容器 */
      width: 792px;
      height: 503px;
      border-radius: 8px;
      overflow: hidden;
      .banner-item {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        position: relative;
        display: flex;
        align-items: flex-end;
        transition: transform 0.45s cubic-bezier(0.2, 0.8, 0.2, 1);
        transform-origin: center;
        will-change: transform;
        /* 鼠标悬浮时稍微放大 */
        &:hover {
          transform: scale(1.03);
        }
      }
    }
    .latestNews {
      width: 384px;
      height: 503px;
      background: #fff;
      border-radius: 12px;
      .newsfire {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 26px;

        .fireleft {
          display: flex;
          align-items: center;
          white-space: nowrap;
          margin-left: 24px;
          img {
            width: 24px;
            margin-right: 2px;
          }
          span {
            font-weight: 600;
            font-size: 20px;
            color: #03102b;
          }
        }
        .trit {
          width: auto;
          display: block;
          text-align: right;
          padding-right: 24px;
          cursor: pointer;

          span {
            font-size: 14px;
            color: #03102b;
            opacity: 0.4;
            vertical-align: middle;
          }

          svg {
            width: 16px;
            height: 16px;
            vertical-align: middle;
            display: inline-block;
            color: #03102b;
            opacity: 0.4;
          }
        }
        .trit:hover {
          span {
            color: #4aab3d;
            opacity: 1;
          }
          svg {
            color: #4aab3d;
            opacity: 1;
          }
        }
      }
      .newslist {
        margin-left: 24px;
        .newrow {
          padding-bottom: 20px;
          border-bottom: 0.5px solid #e5e7eb;
          width: 336px;
          margin-top: 20px;
          cursor: pointer;
        }
        .listtit {
          font-weight: 500;
          font-size: 16px;
          color: #03102b;
          line-height: 24px;
          text-align: left;
          width: 336px;
          margin-bottom: 5px;
          // 文字超出，一行显示，末尾显示省略号
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .listdate {
          font-size: 14px;
          color: #83879b;
          text-align: left;
          line-height: 20px;
        }
        .newrow:last-child {
          border-bottom: none;
        }
        .newrow:hover {
          .listtit {
            color: #4aab3d;
          }
        }
      }
    }
  }
  .section-content {
    margin-top: 24px;
    .news-item {
      margin-bottom: 32px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      span {
        display: inline-block;
        width: 4px;
        height: 4px;
        background: #4aab3d;
        margin-right: 16px;
        border-radius: 50%;
      }
      .news-left {
        display: flex;
        align-items: center;
      }
      .news-title {
        font-size: 16px;
        color: #03102b;
        line-height: 24px;
        text-align: left;
        width: 430px;
        font-weight: 400;
        // 文字超出，一行显示，末尾显示省略号
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .news-title:hover {
        color: #4aab3d;
        cursor: pointer;
      }
      .news-date {
        font-weight: 400;
        font-size: 14px;
        color: #83879b;
        line-height: 22px;
        text-align: left;
        margin-left: 16px;
        white-space: nowrap;
      }
    }
    .news-item:last-child {
      margin-bottom: 0;
    }
  }
  .policy-news {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    gap: 24px;
    margin-top: 24px;
    .policy-section,
    .industry-section {
      width: 540px;
      background: #fff;
      padding: 24px;
      position: relative;
      .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 0.5px solid #e5e7eb;
        padding-bottom: 9px;
      }
      h2 {
        font-size: 20px;
        font-weight: 600;
        color: #03102b;
        line-height: 28px;
        display: flex;
        align-items: center;

        span {
          display: inline-block;
          width: 4px;
          height: 20px;
          background-color: #4aab3d;
          margin-right: 8px;
          border-radius: 4px;
        }
      }
      .trit {
        position: absolute;
        right: 24px;
        top: 24px;
        width: auto;
        display: block;
        text-align: right;
        cursor: pointer;

        span {
          font-size: 14px;
          color: #03102b;
          opacity: 0.4;
          vertical-align: middle;
        }

        svg {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          display: inline-block;
          color: #03102b;
          opacity: 0.4;
        }
      }
      .trit:hover {
        span {
          color: #4aab3d;
          opacity: 1;
        }
        svg {
          color: #4aab3d;
          opacity: 1;
        }
      }
    }
  }
  .column-section {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 24px;
    gap: 24px;
    .column-opinion,
    .deepCaron {
      width: 540px;
      height: 757px;
      position: relative;
      overflow: hidden;
      .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 0.5px solid #e5e7eb;
        padding-bottom: 9px;
      }
      h2 {
        font-size: 20px;
        font-weight: 600;
        color: #03102b;
        line-height: 28px;
        display: flex;
        align-items: center;

        span {
          display: inline-block;
          width: 4px;
          height: 20px;
          background-color: #4aab3d;
          margin-right: 8px;
          border-radius: 4px;
        }
      }
      .trit {
        cursor: pointer;
        span {
          font-size: 14px;
          color: #03102b;
          opacity: 0.4;
          vertical-align: middle;
        }

        svg {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          display: inline-block;
          color: #03102b;
          opacity: 0.4;
        }
      }
      .trit:hover {
        span {
          color: #4aab3d;
          opacity: 1;
        }
        svg {
          color: #4aab3d;
          opacity: 1;
        }
      }
      .section-content {
        height: 304px;
      }
    }
    .column-section-content {
      margin-top: 26px;
      .column-item {
        display: flex;
        gap: 16px;

        margin-bottom: 52px;
        cursor: pointer;
        .colunm-img {
          width: 128px;
          height: 128px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
          }
        }
        .column-txt {
          flex: 1;
          display: flex;
          height: 128px;
          flex-direction: column;
          justify-content: space-between;
          .column-title {
            width: 396px;
            font-size: 16px;
            margin-bottom: 4px;
            color: #03102b;
            line-height: 28px;
            text-align: left;
            font-weight: 500;
            // 文字超出，一行显示，末尾显示省略号
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .column-desc {
            width: 396px;
            font-size: 13px;
            color: #83879b;
            line-height: 23px;
            text-align: justify;
            flex-grow: 1; /* 占满剩余空间 */
            // 多行文本显示，末尾显示省略号
            display: -webkit-box;
            -webkit-line-clamp: 3; /* 显示3行 */
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .column-date {
            display: flex;
            align-items: center;
            justify-content: space-between;
            span {
              font-weight: 400;
              font-size: 14px;
              color: #83879b;
              line-height: 22px;
              text-align: left;
            }
            i {
              display: none;
            }
          }
        }
      }
      .column-item:last-child {
        margin-bottom: 26px;
      }
      .column-item:hover {
        .column-title {
          color: #4aab3d;
        }
        .column-date {
          i {
            display: inline-block;
          }
        }
      }
    }
    .column-opinion {
      background-color: #fff;
      padding: 24px;
    }
    .deepCaron {
      background-color: #fff;
      display: flex;
      padding: 24px;
      flex-direction: column;
    }
    .deep-research,
    .carbon-search {
      position: relative;
      .section-footer {
        width: 592px;
        background-color: #f6f7f8;
        position: absolute;
        bottom: -48px;
        left: -24px;
        height: 24px;
      }
    }
    .carbon-search {
      margin-top: 72px;
    }
  }
}

/* 隐藏 Element 默认箭头（我们用自定义箭头） */
::v-deep .el-carousel__arrow {
  display: none;
}
::v-deep .el-carousel__indicators--outside {
  text-align: left;
}

/* 当只有一条时，强制隐藏指示器（以防仍被渲染） */
::v-deep .single .el-carousel__indicators {
  display: none !important;
}

/* 自定义箭头样式 */
.my-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  //   border-radius: 50%;
  background: none;
  //   color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999; /* 提高 z-index，确保在最上层 */
  cursor: pointer;
  transition: background 0.2s, transform 0.12s;
}
.my-arrow.left {
  left: 32px;
}
.my-arrow.right {
  right: 32px;
}
.my-arrow:hover {
  //   transform: translateY(-50%) scale(1.03);
}

/* 简单图标（可替换为 font-icon 或 svg） */
.icon-left,
.icon-right {
  display: inline-block;

  width: 40px;
  height: 40px;
  img {
    width: 40px;
  }
}

/* 自定义底部小点 */
::v-deep .el-carousel__indicators {
  bottom: 60px;
}
::v-deep .el-carousel__indicators--outside {
  position: relative;
}
::v-deep .el-carousel__indicators--horizontal {
  left: 32px;
}
::v-deep .el-carousel__button {
  width: 32px;
  height: 4px;
  border-radius: 2px;
  opacity: 0.2;
  background-color: #fff;
}

/* banner 内部遮罩与文字 */
.banner-item {
  position: relative;
  background-size: cover;
  background-position: center;
  height: 100%;
  transition: transform 0.45s cubic-bezier(0.2, 0.8, 0.2, 1);
  transform-origin: center;
  will-change: transform;
}
.banner-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(3, 16, 43, 0.8) 0%,
    rgba(3, 16, 43, 0.4) 10%,
    rgba(3, 16, 43, 0) 100%
  );
  pointer-events: none;
  z-index: 1;
}
.banner-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 68px;
  padding-left: 32px;

  color: #fff;
  text-align: left;
  z-index: 2;
}
.banner-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 68px;
  padding-left: 32px;

  color: #fff;
  text-align: left;

  .news-type {
    display: inline-block;
    font-size: 12px;
    margin-bottom: 12px;
    width: 74px;
    height: 24px;
    background: #4aab3d;
    text-align: center;
    line-height: 24px;
  }

  .news-title {
    font-size: 44px;
    font-weight: 600;
    line-height: 56px;
    max-width: 90%;
    text-align: left;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }
}
</style>
